<template>
  <div class="goodsList">
    <div class="recommendedGoodsList infinite-list">
      <div class="recommendedGoodsItem infinite-list-item" v-for="item in lists" :key="item.id">
        <div class="recommendedGoodsItemImg">
          <el-image :src=" item.goods_thum" :lazy="true" fit="cover">
            <div slot="placeholder" class="image-slot">
              <span class="el-icon-loading"></span>加载中...
            </div>
            <div slot="error" class="image-slot" style="color: #c0c4cc">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div class="recommendedGoodsItemInfo">
          <div class="name nowrapEllipsis">
            {{ item.name }}
          </div>

          <div class="price">
            <div class="presentPrice">¥{{ item.sell_price }}</div>
            <div class="originalPrice" v-if="item.line_price">¥{{ item.line_price }}</div>
            <div class="paid" style="margin-right: 1.04167vw;">人气值 {{ item.gmv_sell_num }}</div>

            <!-- <div class="paid">{{ item.sell_num }}人已付款</div> -->
          </div>
        </div>

        <div class="recommendedGoodsItemMask">
          <img class="goodsQR"
            src="https://ppzx168.com/img/qr.bb1d2291.png"
            alt="" />
          <div class="goodsQRText">微信扫码去app下单</div>
        </div>
      </div>
    </div>
    <!-- <infinite-loading spinner="spiral" ref="infiniteLoading" @infinite="infiniteHandler" :distance="200"
      class="infinite-loading-wrap" style="color: #999999; font-size: 0.83333vw">
      <span slot="no-more">到底了亲～</span>
    </infinite-loading> -->
  </div>
</template>

<script>
import { getGoodsList } from "../../utils/api.js";
export default {
  props: {
    list: Array,
    // default: () => ({})
  },
  watch: {
    list(newList) {
      this.lists = newList
    }
  },

  data() {
    return {
      page: {
        page_limit: 4,
        page_num: 1,
      },
      arrList: [],
      lists: this.list,
      state: "",
      parentMounted: false
    };
  },
  // 子组件
  mounted() {
    let pMountedTimer = window.setInterval(() => {
      if (window.parentMounted) {
        window.clearInterval(pMountedTimer)
        this.parentMounted = true
      }
    }, 500)
  },

  methods: {
    infiniteHandler($state) {
      if (this.parentMounted) {
        console.log($state);
        this.state = $state;
        this.getGoodsLists($state);
      }
    },

    getGoodsLists($state) {
      let data = {
        page: this.page,
      };

      getGoodsList(data).then((res) => {
        this.page.page_num++;
        if (res.data.length < this.page.page_limit) {
          this.arrList = this.arrList.concat(res.data);
          $state.complete();
        } else {
          if (res.data.length) {
            this.arrList = this.arrList.concat(res.data);
            this.isList = true;
            $state.loaded();
            if (!this.list.length) {
              this.lists = this.arrList;
              console.log(this.list);
            } else {
              this.lists = this.list
            }
          } else {
            $state.complete();
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.recommendedGoodsList {
  display: flex;
  flex-wrap: wrap;

  .recommendedGoodsItem {
    position: relative;
    cursor: pointer;
    margin-right: 24px;
    margin-bottom: 60px;
    // width: 311px;
    width: 23%;
    height: 408px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(230, 230, 230, 0.5);
    border-radius: 4px;
    // transition: all 0.2s;

    &:nth-child(4n) {
      margin-right: 0;
    }

    &:hover {
      //   margin-top: -5px;
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
      transform: translate3d(0, -2px, 0);
    }

    &:hover .recommendedGoodsItemImg .el-image {
      transform: scale(1.1);
      // transform: translate3d(0, -2px, 0);
    }

    &:hover .recommendedGoodsItemMask {
      display: block;
    }

    .recommendedGoodsItemImg {
      width: 100%;
      height: 311px;
      overflow: hidden;

      .el-image {
        width: 100%;
        height: 311px;
      }
    }

    .recommendedGoodsItemInfo {
      padding: 20px 10px 0 10px;

      .name {
        margin-bottom: 10px;
        font-size: 16px;
        color: #333333;
      }

      .price {
        display: flex;
        align-items: center;

        .presentPrice {
          margin-right: 10px;
          font-size: 18px;
          font-weight: 500;
          color: #ff2442;
        }

        .originalPrice {
          text-decoration: line-through;
          font-size: 16px;
          color: #666666;
        }

        .paid {
          text-align: right;
          flex: 1;
          font-size: 13px;
          color: #999999;
        }
      }
    }

    .recommendedGoodsItemMask {
      text-align: center;
      position: absolute;
      top: 0;
      width: 100%;
      height: 408px;
      background: rgba(0, 0, 0, 0.5);
      display: none;

      .goodsQR {
        width: 232px;
        height: 232px;
        margin-top: 63px;
        margin-bottom: 21px;
      }

      .goodsQRText {
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
}
</style>